import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useUpdatedRef } from '@trend-dev/ui-libs-utils/hooks/useUpdatedRef';

import { useCurrentUserStore } from 'store/currentUser';

import { useSendErrorMetrics } from 'YM/hooks/useErrorMetrics';

import { Provider, provider } from 'providers';

import { getRecordLink } from '../helpers/getRecordLink';
import { useUnavailableVideo } from './useUnavailableVideo';

/** Хук для работы с ссылкой на запись конференции */
export function useRecordLink() {
    const { recordId } = useParams<{ recordId?: string }>();
    const [recordLink, setRecordLink] = useState<string | null>(null);
    const { manageNoRecordLink, manageUnavailableVideo } = useUnavailableVideo();
    const { current: manageUnavailableVideoRef } = useUpdatedRef(manageUnavailableVideo);
    const { currentUser } = useCurrentUserStore();
    const sendErrorMetrics = useSendErrorMetrics();
    const sendErrorMetricsRef = useUpdatedRef(sendErrorMetrics);

    useEffect(() => {
        (async () => {
            if (recordId !== undefined && currentUser) {
                try {
                    const videoCallData = await provider.getConferenceDataForRecord(recordId);

                    if ('statusCode' in videoCallData) manageUnavailableVideoRef(videoCallData);

                    if ('link_to_record' in videoCallData) {
                        const link = getRecordLink(videoCallData.link_to_record);
                        const recordResponse = await Provider.getConferenceRecord(link);

                        if (!manageUnavailableVideoRef(recordResponse)) setRecordLink(link);
                    }
                } catch (error) {
                    sendErrorMetricsRef.current({ data: error, name: 'Попытка получить данные о записи встречи' });
                    manageNoRecordLink();
                }
            }
        })();
    }, [recordId, currentUser]);

    return recordLink;
}
